module.exports = __webpack_public_path__ + "img/westudy_online_screen.057cfae0.png";